import { connect } from 'react-redux';
import { ProductCardLayoutType } from '../../common/models/product';
import { getSelected } from '../../single-choice/utils/selection';
import { CANCELLATION_INSIDE_EU } from '../../products';
import { useProductData } from '../../common/hook/useProductData';
import NewSmallCardLayout from '../../common/components/small-card-layout/NewSmallCardLayout';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = CANCELLATION_INSIDE_EU;
const {
  Small: SMALL_CARD_LAYOUT,
  Main: MAIN_CARD_LAYOUT,
  PostBooking: POSTBOOKING_CARD_LAYOUT
} = ProductCardLayoutType;
const sharedTexts = {
  title: 'cancellationInsideEUTitle',
  readMoreContent: 'cancellationInsideEUReadMoreModalContent',
  persuasionContent: 'cancellationInsideEUPersuasionContent'
};
const mainCardTranslations = {
  ...sharedTexts,
  additionalInformation: 'cancellationInsideEUAdditionalInformation',
  abstractContent: 'cancellationInsideEUAbstract',
  upSell: 'cancellationInsideEUUpSellText'
};
const translations = {
  [MAIN_CARD_LAYOUT]: mainCardTranslations,
  [POSTBOOKING_CARD_LAYOUT]: mainCardTranslations,
  [SMALL_CARD_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'cancellationInsideEUAbstractSmallCard',
    upSell: 'cancellationInsideEUUpSellTextSmallCard'
  }
};
const CancellationInsideEu = _ref => {
  let {
    form,
    isSelected,
    order,
    productPosition,
    layoutType = MAIN_CARD_LAYOUT,
    className,
    sellSpecification
  } = _ref;
  const texts = translations[layoutType] || {};
  const {
    productData,
    rootElement
  } = useProductData({
    productId: PRODUCT_ID,
    order,
    productName: PRODUCT_NAME,
    productPosition,
    isSelected,
    form,
    sellSpecification,
    className,
    texts,
    layoutType,
    productType: 'traveler'
  });
  if (!productData) {
    return null;
  }
  switch (layoutType) {
    case SMALL_CARD_LAYOUT:
      return /*#__PURE__*/_jsx(NewSmallCardLayout, {
        productData: productData,
        ref: rootElement
      });
    case MAIN_CARD_LAYOUT:
    default:
      return /*#__PURE__*/_jsx(ProductLayout, {
        productData: productData,
        ref: rootElement
      });
  }
};
const mapStateToProps = (state, _ref2) => {
  let {
    form
  } = _ref2;
  return {
    isSelected: getSelected(CANCELLATION_INSIDE_EU.name, form)(state)
  };
};
export default connect(mapStateToProps)(CancellationInsideEu);
//# sourceMappingURL=CancellationInsideEu.js.map